import { get } from "svelte/store"
import { navstore, pfadstore } from "./store"
import { apiRequest } from "../../api/hooks/lib/ssr"

export const api = async <T>(endpoint: string, options?: ApiOptions): Promise<ApiResult<T>> => {
    // const span = sentry.currentTransaction()?.startChild({
    //     op: "fetch",
    //     description: method + " " + url,
    //     data: Object.assign({}, options, { url }),
    // })
    // const trace_id = span?.toTraceparent()
    // if (trace_id) {
    //     headers["sentry-trace"] = trace_id
    // }

    const r = await apiRequest(endpoint, options)

    // span?.finish()

    return r
}

export const getContent = async (
    pfad: string,
    lookup: string = "mlpostImage,mlheroImage,tags,rows.cols.image,rows.cols.mlvideoUrl,downloads.download"
): Promise<Content> => {
    const r = await api<Content[]>("content", {
        /* filter: {
            $or: [{ pfad }, { "alternativePfade.pfad": pfad }],
        }, */
        filter: {
            path: "/" + pfad,
        },
        lookup: lookup,
    })

    if (r.data.length) {
        const navElement: NavElement = {
            name: r.data[0].title,
            path: r.data[0].path,
        }
        const currentPfadstore = get(pfadstore)
        if (currentPfadstore) currentPfadstore[r.data[0].path] = navElement

        pfadstore.set(currentPfadstore)

        return r.data[0]
    } else return null
}

export const zeroPad = (num, places) => String(num).padStart(places, "0")

export const getJobs = async (stadt?: string, limit: number = null, sort: string = "updateTime") => {
    let filter: any
    if (stadt) {
        filter["$and"].push({ city: { $in: stadt } })
    }
    const r = await api<Job[]>("job", {
        filter,
        limit,
        sort: sort,
    })

    return r?.data
}

export const getContents = async (
    sprache: string,
    suche: string = null,
    typ: string = null,
    limit: number = null,
    projection: string = "list",
    additionalFilter: any = null,
    tags: any = null,
    sort: string = "sortNum",
    lookup: string = "mlpostImage,mlheroImage,tags"
) => {
    let filter: any = {
        languages: sprache,
        public: true,
        archive: { $ne: true },
        // publishDate: { $lte: new Date() },
    }
    if (sort === "internal") {
        sort = "sortNum"
    }
    if (typ) {
        filter.type = typ
    }
    if (suche) {
        filter["$text"] = { $search: suche }
        filter["public"] = true
        filter["meta.noSearch"] = { $ne: true }
    }
    if (additionalFilter) {
        filter = Object.assign({}, filter, additionalFilter)
    }
    if (tags) {
        filter = { tags: { $all: tags } }
    }
    const r = await api<Content[]>("content", {
        filter,
        limit,
        projection,
        sort: suche ? null : sort,
        lookup: lookup,
    })

    const currentPfadstore = get(pfadstore)
    r.data?.forEach((r) => {
        const navElement: NavElement = {
            name: r.title,
            path: r.path,
        }

        if (currentPfadstore) currentPfadstore[r.path] = navElement
    })
    pfadstore.set(currentPfadstore)
    return r?.data
}

async function ladeNavigation(lang: string) {
    const s = await api<Content[]>("content", {
        filter: {
            languages: lang,
        },
        projection: "selectbox",
    })

    const sMap: { [id: string]: string } = {}
    s.data?.forEach((s) => {
        sMap[s.id] = s.path
    })

    const r = await api<Navigation[]>("navigation", {
        filter: { language: lang },
    })
    const nav: { [key: number]: Navigation } = {}
    const pfade: { [pfad: string]: NavElement } = {}

    function link2Elemente(elements: NavElement[], parent: NavElement = null) {
        elements?.forEach((e) => {
            e.link = sMap[e.page]
            e.parent = parent
            pfade[e.link] = e
            link2Elemente(e.elements, e)
        })
    }

    r.data?.forEach((n) => {
        link2Elemente(n.elements)
        nav[n.tree] = n
    })
    navstore.set(nav)
    pfadstore.set(pfade)
}

// let oldSprache = ""
/* sprache.subscribe((s) => { */
// if (s && s != oldSprache) {
//     oldSprache = s
//     loadNavi(s)
// }
/*     ladeNavigation(s)
}) */

ladeNavigation("de")

// get tags
export const getTags = async (type: TagType) => {
    const r = await api<Tag[]>("tag", {
        filter: {
            type,
        },
        sort: "sort",
    })

    return r?.data
}

// get media
export const getMedia = async (filter: any, sort?: string, projection?: string) => {
    const r = await api<Media[]>("media", {
        filter,
        sort,
        projection,
    })

    return r?.data
}

export const getGeneralInformation = async (): Promise<GeneralInfo[]> => {
    try {
        let response = await api<GeneralInfo[]>("general", {
            method: "get",
            offset: 0,
            limit: 1,
            filter: {
                public: true,
            },
        })
        console.log("response", response.data)
        return response.data
    } catch (e) {
        return null
    }
}
